import { ChipProps } from '@mui/material';
import { ColoredIcon } from '../ColoredIconAndChip';
import ColoredChip from '../ColoredIconAndChip/ColoredChip';
import { STATUS_ICON_MAPPING, useStatusColor } from './constant';
import { TStatus } from './types';

export type TStatusChipsVariant = 'icon-only' | 'label-only' | 'both';
export type TStatusChipProps = {
  status: TStatus;
  label?: string;
  variant?: TStatusChipsVariant;
} & Omit<ChipProps, 'variant'>;

export default function StatusChip({
  status,
  label,
  variant = 'both',
  ...props
}: Readonly<TStatusChipProps>) {
  const iconName = STATUS_ICON_MAPPING[status];
  const color = useStatusColor(status);

  if (!iconName) {
    return <ColoredIcon iconName="remove" />;
  }

  if (variant === 'icon-only') {
    return <ColoredIcon iconName={iconName} isCompact={true} statusColor={color} />;
  }

  return (
    <ColoredChip
      {...props}
      icon={variant === 'both' ? <ColoredIcon iconName={iconName} /> : null}
      statusColor={color}
      label={label ?? status}
    />
  );
}
